import { KINDS } from "../../lib/constants"
import { supabase } from "../../lib/supabase"

type PostFixedPayload = {
  channelId: string
  postId: string
}

export const postFixedCreate = async (payload: PostFixedPayload) => {
  const { channelId, postId } = payload

  const { error } = await supabase
    .from("db")
    .update({
      kind: KINDS.POST_FIXED
    })
    .eq("id", postId)
    .eq("parent_id", channelId)

  if (error) throw error
}
